import dayjs from 'dayjs';

export const money = (value) =>
  value === null || value === undefined
    ? '—'
    : Number(value).toLocaleString('sr-RS', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const date = (value) => (value ? dayjs(value).format('DD.MM.YYYY') : '—');

/** Tag colour per payment status; overdue ones are the red ones. */
export const STATUS_COLORS = {
  paid: 'green',
  partial: 'volcano',
  unpaid: 'red',
  not_due: 'blue',
  no_statement: 'default',
  pending_entry: 'gold',
};

export const STATUSES = Object.keys(STATUS_COLORS);

/** What a return is for; a notice does not say it, so it is picked on import or set later. */
export const CATEGORIES = ['salary', 'transport', 'rent', 'other_income', 'other'];

/** Withholding tax calculations HLB makes on the platform. */
export const CALC_KINDS = ['rent', 'other_income'];

export const CATEGORY_COLORS = {
  salary: 'geekblue',
  transport: 'cyan',
  rent: 'purple',
  other_income: 'magenta',
  other: 'default',
};

export const saveBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const errorText = (t, error) => {
  const key = error?.response?.data?.message || error?.message || '';
  return t(`errors.${key.replace(/^tax_returns\./, '')}`, { defaultValue: key });
};
